/* eslint-disable no-extend-native */
Array.prototype.includesCaseInsensitive = function (value) {
  return this.some((item) => item.toLowerCase() == value.toLowerCase());
};
